import { render, staticRenderFns } from "./InputStructuredText.vue?vue&type=template&id=3cc64384&"
import script from "./InputStructuredText.vue?vue&type=script&lang=js&"
export * from "./InputStructuredText.vue?vue&type=script&lang=js&"
import style0 from "./InputStructuredText.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "InputStructuredText.vue"
export default component.exports